import * as yup from 'yup';
import * as utils from './utils';
import { HistoriquePrixProduit } from '../entities';

export const schemaHistoriquePrixProduit = yup.object<Partial<HistoriquePrixProduit>>({
    name: yup.string().nullable(),
    fk_id_produit: yup.number().nullable(),
    date_debut: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    // methode_facturation: yup.string().nullable(),
    // prix_de_vente_fournisseur: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    // valeur_commission_dollar: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    // valeur_commission_pourcentage: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    // valeur_surfacturation_dollar: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    // valeur_surfacturation_pourcentage: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    // b_taxable: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
}) as yup.ObjectSchema<Partial<HistoriquePrixProduit>>;
